import { render, staticRenderFns } from "./cDocumentList.vue?vue&type=template&id=3debb4db&scoped=true"
import script from "./cDocumentList.vue?vue&type=script&lang=js"
export * from "./cDocumentList.vue?vue&type=script&lang=js"
import style0 from "./cDocumentList.vue?vue&type=style&index=0&id=3debb4db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3debb4db",
  null
  
)

export default component.exports